export const Currencies = ["USD", "GBP", "EUR", "CAD", "AUD"];